export default __webpack_public_path__ + "assets/a6f935e9f97566cad0bee40d5591580d.png";